import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Linkedin, MapPin, Phone, Mail, Send } from 'lucide-react';
import { company, socials, heroImages } from '../mock/data';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const iconMap = { facebook: Facebook, instagram: Instagram, youtube: Youtube, linkedin: Linkedin };
const TikTokIcon = (props) => (<svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.77 20.1a6.34 6.34 0 0 0 10.9-4.42V8.71a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.85-.14Z"/></svg>);

const Footer = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({ title: 'Subscribed', description: `Updates will be sent to ${email}` });
    setEmail('');
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="mb-6">
            <div className="inline-block bg-white rounded-md px-5 py-4">
              <img src={heroImages.logoWhite} alt="Lanka Express Logistics" className="h-20 w-auto object-contain" />
            </div>
          </div>
          <div className="space-y-3 text-sm text-white/70">
            <div className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 text-[#c8102e] shrink-0" /><span>{company.headOfficeAddress}</span></div>
            <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-3 hover:text-[#c8102e] transition-colors"><Phone className="w-4 h-4 text-[#c8102e]" />{company.phone}</a>
            <a href={`mailto:${company.email}`} className="flex items-center gap-3 hover:text-[#c8102e] transition-colors"><Mail className="w-4 h-4 text-[#c8102e]" />{company.email}</a>
          </div>
          <div className="flex items-center gap-2 mt-6">
            {socials.map((s) => {
              const Icon = s.icon === 'tiktok' ? TikTokIcon : iconMap[s.icon];
              if (!Icon) return null;
              return (
                <a key={s.name} href={s.url} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 hover:bg-[#c8102e] hover:border-[#c8102e] flex items-center justify-center transition-colors" aria-label={s.name}>
                  <Icon className="w-4 h-4" />
                </a>
              );
            })}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-5 tracking-[0.2em] uppercase text-white/90">Company</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/" className="hover:text-[#c8102e] transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">Services</Link></li>
            <li><Link to="/about" className="hover:text-[#c8102e] transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[#c8102e] transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-5 tracking-[0.2em] uppercase text-white/90">Services</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">Air Cargo</Link></li>
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">Sea Cargo</Link></li>
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">Road Transportation</Link></li>
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">3PL Services</Link></li>
            <li><Link to="/services" className="hover:text-[#c8102e] transition-colors">Gift Services</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-5 tracking-[0.2em] uppercase text-white/90">Stay Updated</h4>
          <p className="text-sm text-white/70 mb-4">Subscribe for exclusive offers and updates from our team.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="bg-white/5 border-white/15 text-white placeholder:text-white/40 h-11" />
            <Button type="submit" className="bg-[#c8102e] hover:bg-white hover:text-black h-11 px-4"><Send className="w-4 h-4" /></Button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50 tracking-wide">
          <p>© {new Date().getFullYear()} Lanka Express Logistics. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-[#c8102e]">Privacy</a>
            <a href="#" className="hover:text-[#c8102e]">Cookies</a>
            <a href="#" className="hover:text-[#c8102e]">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
